<template>
	<div class="loadmoreSpinner"
	     :id="id"
	     :class="{'hide': !loading}"
	>
		<center>
			<div class="sp sp-circle"></div>
		</center>
	</div>
</template>

<script>
export default {
	name: "SOLoadMoreLoading",
	props: {
		id: String,
		loading: Boolean,
		options: Array,
	},
	data() {
		return {
			observer: null,
		}
	},
	mounted() {
		const options = this.options || {};
		this.observer = new IntersectionObserver(([entry]) => {
		if (entry && entry.isIntersecting) {
			this.$emit("intersect");
		}
		}, options);

		this.observer.observe(this.$el);
	},
	destroyed() {
		this.observer.disconnect();
	},
}
</script>